<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId"
     cdkDropList
     [id]="panel.id + '_resources'"
     [cdkDropListData]="resources"
     [cdkDropListConnectedTo]="connectedPanelIds"
     [cdkDropListSortingDisabled]="true">
  <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="columnGroups"
       [settings]="settings"
       (settingsChange)="onSettingsChange.emit($event)">
    <div class="table-inner-wrapper">
      <div class="resources-table-list-container">
        <div class="tr sticky-header">
          <!-- Merged header for drag, checkbox, and ID -->
          <div class="th col-id sticky-col" translate>
            Resource
            <app-table-column-insert-button></app-table-column-insert-button>
          </div>

          @if (settings?.columns?.agent) {
            <div class="th col-agent" translate>
              Agent
              <app-table-column-insert-button column="agent"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.vehicle) {
            <div class="th col-vehicle" translate>
              Vehicle
              <app-table-column-insert-button column="vehicle"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.logisticVehicle) {
            <div class="th col-logistic-vehicle" translate>
              Logistic Vehicle
              <app-table-column-insert-button column="logisticVehicle"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.timeWindow) {
            <div class="th col-time-window" translate>
              Time Window
              <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.carrier) {
            <div class="th col-carrier" translate>
              Carrier
              <app-table-column-insert-button column="carrier"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.skills) {
            <div class="th col-skills" translate>
              Skills
              <app-table-column-insert-button column="skills"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.labels) {
            <div class="th col-labels" translate>
              Labels
              <app-table-column-insert-button column="labels"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.tags) {
            <div class="th col-tags" translate>
              Tags
              <app-table-column-insert-button column="tags"></app-table-column-insert-button>
            </div>
          }

          @if (settings?.columns?.routesCount) {
            <div class="th col-routes-count" translate>
              Routes
              <app-table-column-insert-button column="routesCount"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.totalDuration) {
            <div class="th col-total-duration" translate>
              Total Duration
              <app-table-column-insert-button column="totalDuration"></app-table-column-insert-button>
            </div>
          }

          <!-- Load Columns -->
          @if (settings?.load?.weight) {
            <div class="th col-load col-load-weight" translate>
              Weight
              <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.volume) {
            <div class="th col-load col-load-volume" translate>
              Volume
              <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.packages) {
            <div class="th col-load col-load-packages" translate>
              Packages
              <app-table-column-insert-button column="packages" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.spots) {
            <div class="th col-load col-load-spots" translate>
              Spots
              <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.pallets) {
            <div class="th col-load col-load-pallets" translate>
              Pallets
              <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.value) {
            <div class="th col-load col-load-value" translate>
              Value
              <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
            </div>
          }

          <!-- Capacity Columns -->
          @if (settings?.capacity?.weight) {
            <div class="th col-capacity col-capacity-weight" translate>
              Weight %
              <app-table-column-insert-button column="weight" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.volume) {
            <div class="th col-capacity col-capacity-volume" translate>
              Volume %
              <app-table-column-insert-button column="volume" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.pallets) {
            <div class="th col-capacity col-capacity-pallets" translate>
              Pallets %
              <app-table-column-insert-button column="pallets" group="capacity"></app-table-column-insert-button>
            </div>
          }

          <div class="th col-actions"></div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!resources" class="flex layout-row layout-align-center-center padding-20">
    <div class="spinner-border" role="status"></div>
  </div>

  <div *ngIf="!!resources && !resources?.length" class="flex layout-row layout-align-center-center padding-20">
    <app-empty-state src="assets/images/empty_state/empty_state_drivers.png" text="No Resources Found"></app-empty-state>
  </div>

  <!-- Body: Handles vertical scrolling and horizontal scrolling -->
  <cdk-virtual-scroll-viewport *ngIf="!!resources && !!resources?.length"
                               class="body-container"
                               [itemSize]="32"
                               #bodyContainer
                               (scroll)="onBodyScroll($event)">

    <div class="table-inner-wrapper">

      <div class="resources-table-list-container">

        <ng-container>
          <div *cdkVirtualFor="let resource of resources; trackBy: trackById"
               class="tr"
               [ngClass]="{'selected': selectedKeys[resource.id]}"
               cdkDropList
               [id]="resource.id"
               [cdkDropListConnectedTo]="connectedPanelIds"
               [cdkDropListSortingDisabled]="true"
               (cdkDropListDropped)="onDrop(resource, $event)"
               (click)="onRowClick(resource)"
               (dblclick)="onRowDoubleClick(resource)">

            <!-- Merged Sticky Column: Checkbox + Color + Name + Edit Button -->
            <div class="td col-id sticky-col">
              <div class="layout-row layout-align-start-center gap-2">
                <div ngbDropdown container="body">
                  <button (click)="$event.stopPropagation();"
                          appBringozIdGenerator="menu-resource-card-resources"
                          class="action-menu"
                          ngbDropdownToggle aria-labelledby="action-menu">
                    <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
                  </button>
                  <div ngbDropdownMenu>
                    <button
                      ngbDropdownItem
                      appBringozIdGenerator="dispatch-routes-resource-card-menu-resources"
                      type="tertiary"
                      (click)="onDispatchClick(resource); $event.stopPropagation()">
                      <div class="layout-row layout-align-start-center">
                        <bringoz-icon iconName="dispatch" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
                        <span class="br-body-2 font-weight-400" translate>Dispatch Routes</span>
                      </div>
                    </button>
                  </div>
                </div>

                <app-bringoz-checkbox [isChecked]="selectedKeys[resource.id]"
                                      (clickEvent)="onToggleSelectedResource(resource.id, !selectedKeys[resource.id]); $event.stopPropagation()"
                                      (click)="$event.stopPropagation()">
                </app-bringoz-checkbox>

                <!-- Edit Resource Allocation Button -->
                <bringoz-button type="tertiary"
                                size="fit"
                                *ngxPermissionsOnly="'planning.update'"
                                (onClick)="onEditResourceAllocationClick(resource, $event); $event.stopPropagation();"
                                (click)="$event.stopPropagation()"
                                [ngbTooltip]="('Edit Resource Allocation' | translate)">
                  <bringoz-icon iconName="edit-outline" classSize="sm" [fill]="resource.excluded ? '#CCCCCC' : '#484848'"></bringoz-icon>
                </bringoz-button>

                <div class="index-border" [style.background-color]="getResourceColor(resource)"></div>
              </div>

              <div class="flex text-ellipsis">
                <span class="br-body-1 text-ellipsis font-weight-600">
                  {{ resource.allocationName || resource.vehicleName }}
                </span>
                <span *ngIf="!resource.allocationId" class="br-body-1">X{{ resource.amount || '---' }}</span>
              </div>
            </div>

            <div *ngIf="settings?.columns?.agent" class="td col-agent gap-5">
              <bringoz-icon iconName="agent" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.agentName || '---' }}</span>
            </div>

            <div *ngIf="settings?.columns?.vehicle" class="td col-vehicle gap-5">
              <bringoz-icon [iconName]="resource.vehicleClass?.toLowerCase() || 'truck'" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.vehicleType?.name || '---' }}</span>
            </div>

            <div *ngIf="settings?.columns?.logisticVehicle" class="td col-logistic-vehicle gap-5 flex-wrap">
              <!--Main Logistic Vehicle-->
              <div class="flex layout-row layout-align-start-center text-ellipsis gap-5">
                <bringoz-icon [iconName]="resource.mainLogisticsVehicleReference?.vehicleType?.toLowerCase() || 'truck'"
                              classSize="sm"
                              fill="#484848">
                </bringoz-icon>
                <span class="br-body-1 text-ellipsis">{{ resource.mainLogisticsVehicleReference?.name || '---' }}</span>
              </div>

              <!--Attached Logistic Vehicles-->
              <div *ngFor="let vehicle of resource.attachedLogisticsVehicleReferences;"
                   class="flex layout-row layout-align-start-center text-ellipsis gap-5">
                <bringoz-icon [iconName]="vehicle.vehicleType?.toLowerCase() || 'Trailer'"
                              classSize="sm"
                              fill="#484848">
                </bringoz-icon>
                <span class="br-body-1 text-ellipsis">{{ vehicle.name || '---' }}</span>
              </div>
            </div>

            <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window gap-5">
              <bringoz-icon iconName="time-window-outline" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource | timeWindow }}</span>
            </div>

            <div *ngIf="settings?.columns?.carrier" class="td col-carrier gap-5">
              <bringoz-icon iconName="carrier" classSize="sm"></bringoz-icon>
              <app-bringoz-state-link *ngIf="!!resource.businessCarrierReference"
                                      class="flex text-ellipsis font-weight-400"
                                      [state]="'accounts-detail-supply.info.preferences'"
                                      [permission]="'accounts.supply.get'"
                                      [params]="{id: resource.businessCarrierReference.id}"
                                      [text]="resource.businessCarrierReference.name"
                                      (click)="$event.stopPropagation()">
              </app-bringoz-state-link>
              <span *ngIf="!resource.businessCarrierReference" class="br-body-1 text-ellipsis">---</span>
            </div>

            <div *ngIf="settings?.columns?.skills" class="td col-skills gap-5">
              <bringoz-icon iconName="tag-outline" classSize="sm"></bringoz-icon>
              <span *ngIf="!resource.allocationSkills?.length" class="br-body-1 text-ellipsis">---</span>
              <app-skill-tags *ngIf="resource.allocationSkills?.length" class="flex" [skillsIds]="resource.allocationSkills" limit="1"></app-skill-tags>
            </div>

            <div *ngIf="settings?.columns?.labels" class="td col-labels gap-5">
              <bringoz-icon iconName="label-outline" classSize="sm"></bringoz-icon>
              <app-bringoz-labels-display *ngIf="!!resource.labels?.length" [labels]="resource.labels" maxItems="1"></app-bringoz-labels-display>
              <span *ngIf="!resource.labels?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <div *ngIf="settings?.columns?.tags" class="td col-tags gap-5">
              <bringoz-icon iconName="tag-outline" classSize="sm"></bringoz-icon>
              <app-bringoz-tags *ngIf="!!resource.tags?.length" [tags]="resource.tags" [maxTags]="1"></app-bringoz-tags>
              <span *ngIf="!resource.tags?.length" class="br-body-1 text-ellipsis">-</span>
            </div>

            <div *ngIf="settings?.columns?.routesCount" class="td col-routes-count gap-5">
              <bringoz-icon iconName="hash" classSize="sm"></bringoz-icon>
              <span class="br-body-2 text-ellipsis">
                {{ ((routesMap[resource.id]?.length || 0) === 1 ? 'X_ROUTE' : 'X_ROUTES') | translate: { sum: (routesMap[resource.id]?.length || 0) } }}
              </span>
            </div>

            <div *ngIf="settings?.columns?.totalDuration" class="td col-total-duration gap-5">
              <bringoz-icon iconName="timer-outline" classSize="sm"></bringoz-icon>
              <span class="br-body-2 text-ellipsis">{{ getResourceTotalDuration(resource) | bringozTimeConvert }}</span>
            </div>

            <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity.weight | bringozWeight:true:'---':true }}</span>
            </div>

            <div *ngIf="settings?.load?.volume" class="td col-load col-load-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity.dimensions?.cube | bringozVolume: false:'---' }}</span>
            </div>

            <div *ngIf="settings?.load?.packages" class="td col-load col-load-packages gap-5">
              <bringoz-icon iconName="package-outline" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity.numberOfPackages || '---' }}</span>
            </div>

            <div *ngIf="settings?.load?.spots" class="td col-load col-load-spots gap-5">
              <bringoz-icon iconName="spot" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity.numberOfSpots || '---' }}</span>
            </div>

            <div *ngIf="settings?.load?.pallets" class="td col-load col-load-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ resource.capacity.numberOfPallets || '---' }}</span>
            </div>

            <div *ngIf="settings?.load?.value" class="td col-load col-load-value gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm"></bringoz-icon>
              <span class="br-body-2 route-total-income">
                {{ resourceTotalsMap[resource.id]?.totalIncome | bringozPrice: '---' }}
              </span>
            </div>

            <!-- Capacity Columns -->
            <div *ngIf="settings?.capacity?.weight" class="td col-capacity col-capacity-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="resource?.capacity?.weight; else unlimitedWeight"
                                        [value]="((resourceTotalsMap[resource.id]?.totalLoad || 0) / resource.capacity.weight) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="weightTooltip">
              </app-bringoz-capacity-bar>

              <ng-template #weightTooltip>
                <span [ngClass]="getWeightSeverity(resource)">
                  {{ ((resourceTotalsMap[resource.id]?.totalLoad || 0) | number: '1.0-2') + (weightUnit | translate) + ' / ' }}
                </span>
                <span *ngIf="resource?.capacity?.weight" [ngClass]="getWeightSeverity(resource)">
                  {{ (resource.capacity.weight | number: '1.0-2') + (weightUnit | translate) + ' = ' + (((resourceTotalsMap[resource.id]?.totalLoad || 0) / resource.capacity.weight) * 100 | number: '1.0-2') + '%' }}
                </span>
                <span *ngIf="!resource?.capacity?.weight" [ngClass]="getWeightSeverity(resource)" translate>
                  UNLIMITED
                </span>
              </ng-template>

              <ng-template #unlimitedWeight>
                <div [ngbTooltip]="weightTooltip" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.volume" class="td col-capacity col-capacity-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="getVolumeCapacity(resource); else unlimitedVolume"
                                        [value]="((resourceTotalsMap[resource.id]?.totalVolume || 0) / getVolumeCapacity(resource)) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="volumeTooltip">
              </app-bringoz-capacity-bar>

              <ng-template #volumeTooltip>
                <span [ngClass]="getVolumeSeverity(resource)">
                  {{ ((resourceTotalsMap[resource.id]?.totalVolume || 0) | number: '1.0-2') + (volumeUnit | translate) + ' / ' }}
                </span>
                <span *ngIf="getVolumeCapacity(resource)" [ngClass]="getVolumeSeverity(resource)">
                  {{ (getVolumeCapacity(resource) | number: '1.0-2') + (volumeUnit | translate) + ' = ' + (((resourceTotalsMap[resource.id]?.totalVolume || 0) / getVolumeCapacity(resource)) * 100 | number: '1.0-2') + '%' }}
                </span>
                <span *ngIf="!getVolumeCapacity(resource)" [ngClass]="getVolumeSeverity(resource)" translate>
                  UNLIMITED
                </span>
              </ng-template>

              <ng-template #unlimitedVolume>
                <div [ngbTooltip]="volumeTooltip" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.pallets" class="td col-capacity col-capacity-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="resource?.capacity?.numberOfPallets; else unlimitedPallets"
                                        [value]="((resourceTotalsMap[resource.id]?.totalPallets || 0) / resource.capacity.numberOfPallets) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="palletsTooltip">
              </app-bringoz-capacity-bar>

              <ng-template #palletsTooltip>
                <span [ngClass]="getPalletsSeverity(resource)">
                  {{ ((resourceTotalsMap[resource.id]?.totalPallets || 0) | number: '1.0-2') + ' / ' }}
                </span>
                <span *ngIf="resource?.capacity?.numberOfPallets" [ngClass]="getPalletsSeverity(resource)">
                  {{ (resource.capacity.numberOfPallets | number: '1.0-2') + ' = ' + (((resourceTotalsMap[resource.id]?.totalPallets || 0) / resource.capacity.numberOfPallets) * 100 | number: '1.0-2') + '%' }}
                </span>
                <span *ngIf="!resource?.capacity?.numberOfPallets" [ngClass]="getPalletsSeverity(resource)" translate>
                  UNLIMITED
                </span>
              </ng-template>

              <ng-template #unlimitedPallets>
                <div [ngbTooltip]="palletsTooltip" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div class="td col-actions"></div>

          </div>
        </ng-container>

      </div>

    </div>
  </cdk-virtual-scroll-viewport>
</div>
